import LegalLayout from './components/LegalLayout';

function Terms() {
  return (
    <LegalLayout title="Terms of Service" effectiveDate="July 19, 2026">
      <p>
        These Terms of Service ("Terms") govern your use of the MintHub website (the
        "Site"), operated by MintHub ("MintHub", "we", "us", or "our"), based in
        Ontario, Canada. By accessing or using the Site, you agree to these Terms. If
        you do not agree, please do not use the Site.
      </p>

      <h2 className="legal-heading">1. Use of the Site</h2>
      <p>
        You may use the Site for lawful purposes only, including learning about our
        services and contacting us for a quote. You agree not to:
      </p>
      <ul>
        <li>Use the contact form to submit spam, malicious code, or unlawful content</li>
        <li>Attempt to gain unauthorized access to the Site or its underlying systems</li>
        <li>Interfere with or disrupt the operation of the Site</li>
      </ul>

      <h2 className="legal-heading">2. Our Services</h2>
      <p>
        Content on the Site (including descriptions of our design, development,
        copywriting, SEO, hosting, and maintenance services) is provided for general
        informational purposes. Specific project scope, pricing, timelines, and
        deliverables for any engagement will be agreed separately between MintHub and
        the client, typically in writing (e.g. via email or a signed proposal). Nothing
        on the Site constitutes a binding offer or guarantee of results.
      </p>

      <h2 className="legal-heading">3. Intellectual Property</h2>
      <p>
        Unless otherwise noted, the text, graphics, logos, and design of the Site are
        owned by MintHub or its licensors and are protected by copyright and other
        intellectual property laws. You may not copy, reproduce, or distribute Site
        content without our prior written permission.
      </p>

      <h2 className="legal-heading">4. Third-Party Links and Services</h2>
      <p>
        The Site may link to third-party platforms, such as our Facebook page, and
        uses a third-party service (FormSubmit.co) to process contact form
        submissions. We are not responsible for the content, policies, or practices of
        any third-party sites or services.
      </p>

      <h2 className="legal-heading">5. Disclaimer of Warranties</h2>
      <p>
        The Site is provided "as is" and "as available" without warranties of any
        kind, express or implied. We do not warrant that the Site will be
        uninterrupted, error-free, or secure.
      </p>

      <h2 className="legal-heading">6. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, MintHub shall not be liable for any
        indirect, incidental, special, or consequential damages arising out of or
        related to your use of the Site, even if we have been advised of the
        possibility of such damages.
      </p>

      <h2 className="legal-heading">7. Changes to These Terms</h2>
      <p>
        We may update these Terms from time to time. Changes will be posted on this
        page with an updated effective date. Continued use of the Site after changes
        are posted constitutes acceptance of the updated Terms.
      </p>

      <h2 className="legal-heading">8. Governing Law</h2>
      <p>
        These Terms are governed by the laws of the Province of Ontario and the
        federal laws of Canada applicable therein, without regard to conflict of law
        principles. Any disputes arising from these Terms or your use of the Site will
        be subject to the exclusive jurisdiction of the courts of Ontario, Canada.
      </p>

      <h2 className="legal-heading">9. Contact Us</h2>
      <p>
        Questions about these Terms can be directed to{' '}
        <a href="mailto:minthub.business@protonmail.com">minthub.business@protonmail.com</a>.
      </p>
    </LegalLayout>
  );
}

export default Terms;
